import gql from 'graphql-tag';

export const GET_USER_QUERY = gql`
  query UserFindOne($where: UserWhereUniqueInput!) {
    UserFindOne(where: $where) {
      id
      roles {
        roleId
        role {
          name
          allowedModules
        }
      }
      email
      username
      isActive
    }
  }
`;
